import KeyCodes from './KeyCodes';
/**
 * Get the `keyCode` or `which` value from a keyboard event or key name.
 * @param event A keyboard event like object or key name.
 */

export default function getKeyCode(event) {
  if (typeof event === 'string') {
    return KeyCodes[event];
  }

  return event.keyCode || event.which;
}
//# sourceMappingURL=getKeyCode.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/blaze-consumer/~/@flowio/browser-helpers/lib/esm/getKeyCode.js
// module id = 468
// module chunks = 0 1